// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Sidebar_logoContainer__3551k","navLinks":"Sidebar_navLinks__2a5X9","active":"Sidebar_active__YxoaX"};